import { ErrorHandler, Injectable } from '@angular/core';

import { LoggingService } from './logging.service';

@Injectable({
	providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {

	constructor(private readonly loggingService: LoggingService) {
		super();
	}

	handleError(error: Error): void {
		console.error(error);
		this.loggingService.logException(error);
	}
}
